<!-- Header -->
<div class="modal-header">
    <div class="title">
        <h2 class="modal-title" *ngIf="this.role === 'Provider'">Nouveau fournisseur</h2>
        <h2 class="modal-title" *ngIf="this.role === 'Shop'">Nouvel adhérent</h2>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<!-- Body -->
<div class="modal-body d-flex flex-column ">
    <div class="info-modify">
        <div class="container">
            <!-- Fields -->
            <div class="row">
                <div class="col">
                    <label for="lastName" class="form-label required">Nom</label>
                    <input type="text" class="form-control" id="lastName" [(ngModel)]="this.lastName">
                </div>

                <div class="col">
                    <label for="firstName" class="form-label required">Prénom</label>
                    <input type="text" class="form-control" id="firstName" [(ngModel)]="this.firstName">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="email" class="form-label required">Email</label>
                    <input type="email" class="form-control" id="email" [(ngModel)]="this.email">
                </div>
                <div class="col">
                    <label for="phone" class="form-label required">N° téléphone</label>
                    <input type="text" class="form-control" id="phone" [(ngModel)]="this.phone">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="nameOrganization" class="form-label required">Société</label>
                    <input type="text" class="form-control" id="nameOrganization" [(ngModel)]="this.nameOrganization">
                </div>
                <div class="col">
                    <label for="password" class="form-label required">Mot de passe</label>
                    <input title="Doit contenir au minimum 8 caractères, au moins une lettre minuscule et une lettre majuscule, un caractère spécial et un chiffre." type="password" class="form-control" id="password" [(ngModel)]="this.password">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="address" class="form-label required">Adresse</label>
                    <input type="text" class="form-control" id="address" [(ngModel)]="this.address">
                </div>
                <div class="col">
                    <label for="codePostal" class="form-label required">Code Postal</label>
                    <input type="text" class="form-control" id="codePostal" [(ngModel)]="this.codePostal">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="city" class="form-label required">Ville</label>
                    <input type="text" class="form-control" id="city" [(ngModel)]="this.city">
                </div>
                <div class="col">
                    <label for="country" class="form-label required">Pays</label>
                    <input type="text" class="form-control" id="country" [(ngModel)]="this.country">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="lat" class="form-label required">Latitude</label>
                    <input type="text" class="form-control" id="lat" [(ngModel)]="this.lat">
                </div>
                <div class="col">
                    <label for="long" class="form-label required">Longitude</label>
                    <input type="text" class="form-control" id="long" [(ngModel)]="this.long">
                </div>

                <div class="w-100"></div>

                <div class="col" *ngIf="this.role === 'Provider'">
                    <label for="network" class="form-label required">Réseaux</label>
                    <div class="network-block provider">
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="this.networks" multiple>
                                <mat-option *ngFor="let network of networkList" [value]="network">{{network}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="bankName" class="form-label required">Nom de la banque</label>
                    <input type="text" class="form-control" id="bankName" [(ngModel)]="this.bankName">
                </div>
                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="iban" class="form-label required">IBAN</label>
                    <input type="text" class="form-control" id="iban" [(ngModel)]="this.IBAN">
                </div>

                <div class="w-100" *ngIf="this.role === 'Shop'"></div>

                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="payzenId" class="form-label required">Identifiant de Payzen</label>
                    <input type="text" class="form-control" id="payzenId" [(ngModel)]="this.payzenId">
                </div>
                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="payzenPrivateKey" class="form-label required">Clé privée de Payzen</label>
                    <input type="text" class="form-control" id="payzenPrivateKey" [(ngModel)]="this.payzenPrivateKey">
                </div>

                <div class="w-100" *ngIf="this.role === 'Shop'"></div> -->

                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="subDomainName" class="form-label required">Site de l'adhérent</label>
                    <input type="text" class="form-control" id="subDomainName" [(ngModel)]="this.subDomainName">
                </div>
                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="network" class="form-label required">Réseaux</label>
                    <div class="network-block shop">
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="this.networks">
                                <mat-option *ngFor="let network of networkList" [value]="network">{{network}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="w-100" *ngIf="this.role === 'Shop'"></div>

                <div class="col">
                    <label class="form-label">Logo</label>
                    <input #imageInput type="file" ng2FileSelect accept="image/*"
                        class="form-control input-logo" (change)="processImage($event)">
                    <label id="isNotValidImage" style="color: #D80000; display: none;">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        L'image doit être inférieur à 5 Mo
                    </label>
                    <label id="isValidImage" style="color: #4DCC5E; display: none;">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Téléchargé
                    </label>
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="description" class="form-label">Description</label>
                    <textarea type="text" class="form-control" id="description"
                        [(ngModel)]="this.description"></textarea>
                </div>

                <div class="w-100" *ngIf="this.role === 'Shop'"></div>

                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="isWeb" class="form-label required">Autoriser les commandes en ligne</label>
                    <div>
                        <mat-radio-group>
                            <mat-radio-button color="primary" value="isWeb" (change)="filterWeb($event)">Oui
                            </mat-radio-button>
                            <mat-radio-button color="primary" value="isNotWeb" (change)="filterWeb($event)">Non
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="isPriseCote" class="form-label required">Prise de côte</label>
                    <div>
                        <mat-radio-group>
                            <mat-radio-button color="primary" value="isPriseCote" (change)="filterPriseCote($event)">Oui
                            </mat-radio-button>
                            <mat-radio-button color="primary" value="isNotPriseCote" (change)="filterPriseCote($event)">Non
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="isFitting" class="form-label required">Proposer la pose à domicile</label>
                    <div>
                        <mat-radio-group>
                            <mat-radio-button color="primary" value="isFitting" (change)="filterFitting($event)">Oui
                            </mat-radio-button>
                            <mat-radio-button color="primary" value="isNotFitting" (change)="filterFitting($event)">Non
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 d-flex flex-column modify-block">
        <button class="modify" (click)="addUser()">
            Ajouter l’utilisateur
        </button>
    </div>
</div>